// import qs from 'qs';
import _ from 'lodash';
import request from '../../../../shared/lib/request';
import { RPC } from '../../../../shared/constants';

const getComuni = (text) =>
  request({
    url: RPC.PROXY,
    method: 'POST',
    data: {
      method: 'GET',
      route: `municipality?filter[0][type]=neq&filter[0][field]=automotiveAbbreviation&filter[0][value]=EE&filter[1][type]=like&filter[1][field]=denomination&filter[1][value]=${text}%&order-by[0][type]=field&order-by[0][field]=denomination&order-by[0][direction]=asc&fields=denomination,cadastralCode,regionName,automotiveAbbreviation`,
      microserviceName: 'municipality',
      params: {},
      headers: {},
    },
  }).then((res) =>
    _.get(res, '_embedded.municipality', []).map((comune) => ({
      value: comune.denomination,
      label: comune.denomination,
      cadastralCode: comune.cadastralCode,
      provincia: comune.automotiveAbbreviation,
      regione: comune.regionName,
      comune: comune.denomination,
    }))
  );

const getNazioni = (text) =>
  request({
    url: RPC.PROXY,
    method: 'POST',
    data: {
      method: 'GET',
      route: `municipality?filter[0][type]=eq&filter[0][field]=automotiveAbbreviation&filter[0][value]=EE&filter[1][type]=like&filter[1][field]=denomination&filter[1][value]=${text}%&order-by[0][type]=field&order-by[0][field]=denomination&order-by[0][direction]=asc&fields=denomination,cadastralCode`,
      microserviceName: 'municipality',
      params: {},
      headers: {},
    },
  }).then((res) =>
    _.get(res, '_embedded.municipality', []).map((nazione) => ({
      value: nazione.denomination,
      label: nazione.denomination,
      cadastralCode: nazione.cadastralCode,
    }))
  );

const getComuniNazioni = (text) =>
  request({
    url: RPC.PROXY,
    method: 'POST',
    data: {
      method: 'GET',
      route: `municipality?filter[0][type]=like&filter[0][field]=denomination&filter[0][value]=${text}%`,
      microserviceName: 'municipality',
      params: {},
      headers: {},
    },
  }).then((res) =>
    _.get(res, '_embedded.municipality', []).map((comune) => ({
      value: comune.denomination,
      label: comune.denomination,
      cadastralCode: comune.cadastralCode,
      provincia: comune.automotiveAbbreviation,
      regione: comune.regionName,
      comune: comune.denomination,
    }))
  );

const getComuniOptions = (inputValue) => getComuni(inputValue).then((data) => ({ options: data }));
const getNazioniOptions = (inputValue) => getNazioni(inputValue).then((data) => ({ options: data }));
const getComuniNazioniOptions = (inputValue) => getComuniNazioni(inputValue).then((data) => ({ options: data }));

export const ComuniService = {
  getComuni,
  getComuniOptions,
};

export const NazioniService = {
  getNazioni,
  getNazioniOptions,
};

export const ComuniNazioniService = {
  getComuniNazioni,
  getComuniNazioniOptions,
};



// WEBPACK FOOTER //
// ./app/shared/services/rpc/comune/index.js